import { ReactElement } from 'react';
import { SearchPage } from './search/SearchPage';
import { PaymentDetailPage } from './paymentDetails/PaymentDetailPage';
import { FileDetailPage } from './fileDetails/FileDetailPage';
import { BulkPaymentsPage } from './bulk_payments/BulkPaymentsPage';
import { BulkFilesPage } from './bulk_files/BulkFilesPage';
import { ExecutionsByStatusPage } from './executions_by_status/ExecutionsByStatusPage';

export interface Page {
  path: string;
  title: string;
  content: ReactElement;
  matchExactPath: boolean;
  description?: string;
}

export const searchPage: Page = {
  path: '/',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const searchAltPage: Page = {
  path: '/search',
  title: 'Search',
  content: <SearchPage />,
  matchExactPath: true,
  description: 'Beacon payment search',
};

export const paymentDetailPage: Page = {
  path: '/payment',
  title: 'Payment Detail',
  content: <PaymentDetailPage />,
  matchExactPath: true,
  description: 'Payment lifecycle detail view',
};

export const fileDetailPage: Page = {
  path: '/file',
  title: 'File Detail',
  content: <FileDetailPage />,
  matchExactPath: true,
  description: 'File lifecycle detail view',
};

export const bulkPaymentsPage: Page = {
  path: '/payments',
  title: 'Bulk Payments',
  content: <BulkPaymentsPage />,
  matchExactPath: true,
  description: 'Bulk payment search results',
};

export const bulkFilesPage: Page = {
  path: '/files',
  title: 'Bulk Files',
  content: <BulkFilesPage />,
  matchExactPath: true,
  description: 'Bulk file search results',
};

export const executionsByStatusPage: Page = {
  path: '/executions/by-status',
  title: 'Filter Executions',
  content: <ExecutionsByStatusPage />,
  matchExactPath: true,
  description: 'Filter executions by status, state, dataSource, and date range',
};

/**
 * All pages in route order.
 */
export const allPages: Page[] = [
  searchPage,
  searchAltPage,
  paymentDetailPage,
  fileDetailPage,
  bulkPaymentsPage,
  bulkFilesPage,
  executionsByStatusPage,
];
